let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e7R8N")).then(() => parcelRequire('cVpTe'));